import React from "react";

export const Page2English = () => {
  return (
    <div className="page-container">
      <h1>To the south:</h1>
      <p>
        In the Kachanam, which was originally called Kaichinnam, there is the
        Sri Kaichinnaswarar Temple, which was worshipped by Indra.
      </p>
      <h1>To the east:</h1>
      <p>
        In the Thirukkuvala, which was originally called Thirukolili, there is
        the Koliliyappar Temple, which was originally called Thirukkolili.
      </p>
      <h1>To the west:</h1>
      <p>
        In the Thirunellikkaval, which was originally called Nellivanam, there
        is the Nellivana Nadhar Temple.
      </p>
      <p>
        All the four sacred places mentioned above are about half a kilometer
        away from the village limits of Kolapadu. Since holy places are located
        in all four directions,<strong>Kolappadu</strong> , which is located in
        the middle, is also a holy place.
      </p>
      <h1>Town and name:</h1>
      <p>
        The place where the Shiva Adhiyannan and Ayyanar temples are located,
        was once a meadow. Cows used to graze there. One day, it rained heavily
        and the ground was muddy. A cow stepped into the mud. Where its hoof had
        stepped, there was a Shiva lingam. The head of the lingam has a cow's
        hoof imprinted on it. Seeing this, the people took the Shiva lingam and
        named it Kulambadi Nathar and built a small temple to worship it. Later,
        the town was given the name Kolambadi and later the name Kolappadu was
        derived. However, to confirm this, you can still see the head of the
        Shiva lingam located in the Shiva temple in Kulambadu.
      </p>
      <p>
        "Don't live in a town without a temple" is the old saying. In Kolapadu
        village, as the saying goes, there is a temple for every street, there
        are many temples on the main street, such as Sri Chellamuthu Mariamman
        Temple, Vinayagar Temple - Kasi Vishwanath Temple. There is also a
        Pitari Temple with idols of two Pitaris
      </p>
      <p>
        The Chithirai festival is celebrated in the Mariamman Temple and the
        Vaikasi Visakha festival in the Shiva Temple is celebrated in a very
        special way - chariots, theppam, thimithi, and Panchamurthi are also
        celebrated in a special way by the villagers.
      </p>
     
    </div>
  );
};
